import React from "react"
import cx from "classnames"

export type CellPropsType = {
  children?: React.ReactNode
  divided?: boolean
  className?: string
}
export type CellSoftPropsType = {
  children?: React.ReactNode
  softDivided?: boolean
  className?: string
}

export type CellsPropsType = {
  content: CellPropsType["children"][]
} & Omit<CellPropsType, "children">
export type CellsSoftPropsType = {
  content: CellSoftPropsType["children"][]
} & Omit<CellSoftPropsType, "children">

function Cell(props: CellPropsType): JSX.Element
function Cell(props: CellSoftPropsType): JSX.Element
function Cell({
  children,
  divided,
  softDivided,
  className,
}: CellPropsType & CellSoftPropsType): JSX.Element {
  return (
    <div
      className={cx("cobalt-cell", className, {
        "cobalt-cell--divided": divided,
        "cobalt-cell--softDivided": softDivided,
      })}
    >
      {children}
    </div>
  )
}

export function Cells(props: CellsPropsType): JSX.Element
export function Cells(props: CellsSoftPropsType): JSX.Element
export function Cells({
  content,
  ...cellProps
}: CellsPropsType & CellsSoftPropsType): JSX.Element {
  return (
    <>
      {content.map((c, i) => (
        <Cell key={i} {...cellProps}>
          {c}
        </Cell>
      ))}
    </>
  )
}

export default Cell
